import { number as cardNumberValidator } from '@ott/utility-card-validator';
import { switchLang, removeNonNumbers } from '@ott/transforms';
import { translateFormatter } from '@ott/utility-formatters';

const SPACE_PAT = /\s/g;
const DASH_PAT = /\-/g;
const NULL_PAT = /null/g;

const FULL_YEAR_LENGTH = 4;

const onlyDigits = (v) => v && removeNonNumbers(v);

const isEmptyDate = (v) => (!v ? true : v.replace(DASH_PAT, '').replace(NULL_PAT, '') === '');

const getCardNumberMaxLength = (v) => {
  const { card } = cardNumberValidator(v);
  const cardLengths = card && card.lengths;
  const length = cardLengths && cardLengths[cardLengths.length - 1];
  return Number.isInteger(length) ? length : 19;
};

const parseNumber = (v) => {
  const maxLength = getCardNumberMaxLength(v);
  return v && removeNonNumbers(v).substr(0, maxLength).replace(SPACE_PAT, '');
};

const parseCVV = (v) => v && onlyDigits(v).substr(0, 4);
const formatCVV = (v) => v && removeNonNumbers(v);

const parseExpMonth = (value, { isFocused }) => {
  if (isEmptyDate(value)) {
    return '';
  }

  const parsedMonth = removeNonNumbers(value).substr(0, 2);

  if (!isFocused && parsedMonth.length === 1) {
    return parsedMonth.padStart(2, '0');
  }

  return parsedMonth;
};

const parseExpYear = (value) => {
  if (isEmptyDate(value)) {
    return '';
  }

  const parsedYear = removeNonNumbers(value);

  // если вставили полный год
  if (parsedYear.length === FULL_YEAR_LENGTH) {
    return parsedYear.substr(2, 2);
  }

  return parsedYear.substr(0, 2);
};

const formatExpMonth = (value, prevValue, cursor, { isFocused }) => {
  if ((isFocused && value && value.length < 2) || !value) {
    return { value, cursor };
  }

  const parsedMonth = removeNonNumbers(value);
  if (parsedMonth.length === 1) {
    return { value: parsedMonth.padStart(2, '0'), cursor: 2 };
  }

  return { value: parsedMonth, cursor: parsedMonth.length };
};

const formatExpYear = (value, prevValue, cursor, { isFocused }) => {
  if ((isFocused && value && value.length < 2) || !value) {
    return { value, cursor };
  }

  const parsedYear = removeNonNumbers(value);
  return { value: parsedYear, cursor: parsedYear.length };
};

module.exports = {
  holderName: {
    parse: (v) => switchLang(v),
    formatter: translateFormatter,
  },
  expMonth: {
    parse: parseExpMonth,
    formatter: formatExpMonth,
  },
  expYear: {
    parse: parseExpYear,
    formatter: formatExpYear,
  },
  cvv: {
    parse: parseCVV,
    format: formatCVV,
  },
  number: {
    format: parseNumber,
    parse: parseNumber,
  },
};
